export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7896.cb88b007.jpg";